import { createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createStaticVNode as _createStaticVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3d568d2a")

_pushScopeId("data-v-3d568d2a")
const _hoisted_1 = { class: "head" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "exit_to_app", -1)
const _hoisted_3 = { class: "label moreBtn" }
const _hoisted_4 = /*#__PURE__*/_createVNode("i", {
  class: "material-icons",
  style: {"padding-bottom":"2px","font-size":"18px"}
}, "expand_more", -1)
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Project ")
const _hoisted_6 = { class: "moreMenu" }
const _hoisted_7 = { class: "center" }
const _hoisted_8 = { class: "size" }
const _hoisted_9 = /*#__PURE__*/_createVNode("span", { class: "label" }, "x", -1)
const _hoisted_10 = /*#__PURE__*/_createVNode("span", { class: "label" }, "frames", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "cloud_upload", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Live sync", -1)
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createVNode("div", { class: "dot" }, null, -1)
const _hoisted_15 = { class: "detail" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "save", -1)
const _hoisted_18 = { class: "text" }
const _hoisted_19 = /*#__PURE__*/_createVNode("span", { class: "material-icons" }, "get_app", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text" }, "Download", -1)
const _hoisted_21 = /*#__PURE__*/_createStaticVNode(" This is the AdvancedGUI web editor developed by <a href=\"https://leoko.dev/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-3d568d2a>Leo Garbe</a>. <br data-v-3d568d2a> AdvancedGUI is a game extension for the sandbox video game Minecraft. It is available for purchase on <a href=\"https://www.spigotmc.org/resources/advancedgui-interactive-itemframe-guis.83636/\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-3d568d2a>SpigotMC</a>. <br data-v-3d568d2a> The code of this edtor is open-source on <a href=\"https://github.com/DevLeoko/AdvancedGUI-Web\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-3d568d2a>GitHub</a>. <br data-v-3d568d2a> For support join our <a href=\"https://discord.gg/ycDG6rS\" target=\"_blank\" rel=\"noopener noreferrer\" data-v-3d568d2a>Discord</a>. <br data-v-3d568d2a><br data-v-3d568d2a>", 17)
const _hoisted_38 = /*#__PURE__*/_createVNode("p", { class: "shortcuts" }, [
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "C"),
  /*#__PURE__*/_createTextVNode("   Copy component "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "V"),
  /*#__PURE__*/_createTextVNode("   Paste component "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "X"),
  /*#__PURE__*/_createTextVNode("   Copy & delete component "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "DELETE"),
  /*#__PURE__*/_createTextVNode("   Delete component "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "Z"),
  /*#__PURE__*/_createTextVNode("   Undo "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "Y"),
  /*#__PURE__*/_createTextVNode("   Redo "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "SCROLL"),
  /*#__PURE__*/_createTextVNode("   Zoom in/out "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "ARROW KEY"),
  /*#__PURE__*/_createTextVNode("   Move component by 1 pixel "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "SHIFT"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "ARROW KEY"),
  /*#__PURE__*/_createTextVNode("   Move component by 10 pixel "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("span", null, "CTRL"),
  /*#__PURE__*/_createTextVNode(),
  /*#__PURE__*/_createVNode("span", null, "S"),
  /*#__PURE__*/_createTextVNode("   Download savepoint "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" Press "),
  /*#__PURE__*/_createVNode("span", null, "SHIFT"),
  /*#__PURE__*/_createTextVNode(" while moving an element to snap to x- or y-axis ")
], -1)
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "placeholderContent" }, [
  /*#__PURE__*/_createVNode("p", null, " Placeholders can be used in any text field: component texts, commands, messages, image URLs and checks. "),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createVNode("b", null, "Instance placeholders"),
    /*#__PURE__*/_createTextVNode(" resolve against the placed GUI, which makes layouts "),
    /*#__PURE__*/_createVNode("i", null, "portable"),
    /*#__PURE__*/_createTextVNode(": place the GUI somewhere else and commands that interact with the world keep working without being edited. On wall GUIs the anchor is the top-left item frame; handheld GUIs resolve against the player holding the map. ")
  ]),
  /*#__PURE__*/_createVNode("p", { class: "placeholders" }, [
    /*#__PURE__*/_createVNode("span", null, "%instance.x%"),
    /*#__PURE__*/_createTextVNode(),
    /*#__PURE__*/_createVNode("span", null, "%instance.y%"),
    /*#__PURE__*/_createVNode("span", null, "%instance.z%"),
    /*#__PURE__*/_createTextVNode("   Anchor block coordinates "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.pos%"),
    /*#__PURE__*/_createTextVNode("   Anchor as \"x y z\" — drop-in for command coordinates "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.world%"),
    /*#__PURE__*/_createTextVNode("   World name "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.direction%"),
    /*#__PURE__*/_createTextVNode("   Facing of the GUI (handheld: of the player) "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.center%"),
    /*#__PURE__*/_createTextVNode("   Center of the GUI plane (may contain decimals) "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.id%"),
    /*#__PURE__*/_createTextVNode("   Instance id (handheld: map id) "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.layout%"),
    /*#__PURE__*/_createTextVNode("   Layout name "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.offset.<dx>.<dy>.<dz>%"),
    /*#__PURE__*/_createTextVNode("   Anchor shifted along the world axes, as \"x y z\" "),
    /*#__PURE__*/_createVNode("br"),
    /*#__PURE__*/_createVNode("span", null, "%instance.rel.<right>.<up>.<front>%"),
    /*#__PURE__*/_createTextVNode("   Anchor shifted relative to the GUI's orientation — "),
    /*#__PURE__*/_createVNode("i", null, "front"),
    /*#__PURE__*/_createTextVNode(" points out of the screen towards the viewer "),
    /*#__PURE__*/_createVNode("br")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Example: "),
    /*#__PURE__*/_createVNode("span", { class: "placeholders-chip" }, " /setblock %instance.rel.0.0.-1% air"),
    /*#__PURE__*/_createTextVNode(" always targets the block the top-left frame hangs on, no matter where the GUI is placed or which way it faces. ")
  ]),
  /*#__PURE__*/_createVNode("p", null, [
    /*#__PURE__*/_createTextVNode(" Also available: "),
    /*#__PURE__*/_createVNode("span", { class: "placeholders-chip" }, "%meta.<key>%"),
    /*#__PURE__*/_createTextVNode(" (values stored by metadata actions), and every "),
    /*#__PURE__*/_createVNode("a", {
      href: "https://wiki.placeholderapi.com/users/placeholder-list/",
      target: "_blank",
      rel: "noopener noreferrer"
    }, "PlaceholderAPI"),
    /*#__PURE__*/_createTextVNode(" placeholder when installed on the server. ")
  ])
], -1)
const _hoisted_40 = /*#__PURE__*/_createVNode("p", null, [
  /*#__PURE__*/_createTextVNode(" The AdvancedGUI web editor is designed to have a very intuitive user interface. But some users might require some more advanced features that would only confuse or dirsturb the average user. This is why we added "),
  /*#__PURE__*/_createVNode("b", null, "dev-mode"),
  /*#__PURE__*/_createTextVNode(". "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" You can toggle the dev-mode by clicking on the "),
  /*#__PURE__*/_createVNode("span", {
    class: "material-icons",
    style: {"font-size":"16px","vertical-align":"middle"}
  }, "tune"),
  /*#__PURE__*/_createTextVNode("-icon next to "),
  /*#__PURE__*/_createVNode("i", null, "\"General setting\""),
  /*#__PURE__*/_createTextVNode(" in the left options tab. "),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode(" The dev-mode allows you to: ")
], -1)
const _hoisted_41 = /*#__PURE__*/_createVNode("ul", null, [
  /*#__PURE__*/_createVNode("li", null, "Move component partially outside of the GUI view"),
  /*#__PURE__*/_createVNode("li", null, "Change the ID of components"),
  /*#__PURE__*/_createVNode("li", null, "Preview how the GUI will be divided into item-frames"),
  /*#__PURE__*/_createVNode("li", null, " Preview the GUI in the exact colors Minecraft will render "),
  /*#__PURE__*/_createVNode("li", null, " Set the direct RGBA color value of components (useful for using template variables for colors) ")
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", {
      class: "exitBtn",
      onClick: _cache[1] || (_cache[1] = $event => (_ctx.exitToExplorer()))
    }, [
      _hoisted_2
    ]),
    _createVNode("b", _hoisted_3, [
      _hoisted_4,
      _hoisted_5,
      _createVNode("div", _hoisted_6, [
        _createVNode("div", {
          class: "entry",
          onClick: _cache[2] || (_cache[2] = $event => (_ctx.showShortcuts = true))
        }, "Shortcuts"),
        _createVNode("div", {
          class: "entry",
          onClick: _cache[3] || (_cache[3] = $event => (_ctx.showPlaceholders = true))
        }, "Placeholders"),
        _createVNode("div", {
          class: "entry",
          onClick: _cache[4] || (_cache[4] = $event => (_ctx.showDevMode = true))
        }, "Dev-Mode"),
        _createVNode("div", {
          class: "entry",
          onClick: _cache[5] || (_cache[5] = $event => (_ctx.showAbout = true))
        }, "About")
      ])
    ]),
    _createVNode("div", _hoisted_7, [
      _withDirectives(_createVNode("input", {
        class: "inputProjectName",
        type: "text",
        "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => (_ctx.settings.projectName = $event))
      }, null, 512), [
        [_vModelText, _ctx.settings.projectName]
      ]),
      _createVNode("div", _hoisted_8, [
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => (_ctx.settings.width = $event))
        }, null, 512), [
          [_vModelText, _ctx.settings.width]
        ]),
        _hoisted_9,
        _withDirectives(_createVNode("input", {
          type: "number",
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => (_ctx.settings.height = $event))
        }, null, 512), [
          [_vModelText, _ctx.settings.height]
        ]),
        _hoisted_10
      ])
    ]),
    (_ctx.syncStatus == _ctx.SyncStatus.DISCONNECTED)
      ? (_openBlock(), _createBlock("div", {
          key: 0,
          class: "btn sync",
          onClick: _cache[9] || (_cache[9] = $event => (_ctx.openSyncPrompt()))
        }, [
          _hoisted_11,
          _hoisted_12
        ]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: ["syncStatus", _ctx.syncStatus != _ctx.SyncStatus.CONNECTED ? 'pending' : '']
        }, [
          _createVNode("div", _hoisted_13, [
            _hoisted_14,
            _createTextVNode(" " + _toDisplayString(_ctx.syncStatus == _ctx.SyncStatus.CONNECTED ? "Connected" : "Syncing..."), 1 /* TEXT */)
          ]),
          _createVNode("div", _hoisted_15, [
            _createVNode("a", {
              onClick: _cache[10] || (_cache[10] = $event => (_ctx.syncStatus = _ctx.SyncStatus.DISCONNECTED))
            }, "Disconnect"),
            (_ctx.syncType == _ctx.SyncType.MANUAL)
              ? (_openBlock(), _createBlock("span", _hoisted_16, "| Use '/ag pull' to apply changes"))
              : _createCommentVNode("", true)
          ])
        ], 2)),
    _createVNode("div", {
      class: ["btn save", 
        !_ctx.unsavedChange || _ctx.syncStatus == _ctx.SyncStatus.SYNCING ? 'inactive' : ''
      ],
      onClick: _cache[11] || (_cache[11] = (...args) => (_ctx.saveCurrentProject(...args)))
    }, [
      _hoisted_17,
      _createVNode("span", _hoisted_18, "Save" + _toDisplayString(_ctx.syncStatus != _ctx.SyncStatus.DISCONNECTED ? " & sync" : ""), 1)
    ], 2),
    _createVNode("div", {
      class: "btn export",
      onClick: _cache[12] || (_cache[12] = $event => (_ctx.exportCurrentProject()))
    }, [
      _hoisted_19,
      _hoisted_20
    ]),
    _createVNode(_component_modal, {
      title: "About this page",
      icon: "help_outline",
      modelValue: _ctx.showAbout,
      "onUpdate:modelValue": _cache[13] || (_cache[13] = $event => (_ctx.showAbout = $event)),
      closeBtn: ""
    }, {
      default: _withId(() => [
        _createVNode("p", null, [
          _hoisted_21,
          _createTextVNode(" Current format-version: " + _toDisplayString(_ctx.formatVersion), 1 /* TEXT */)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      title: "Shortcuts",
      icon: "keyboard",
      modelValue: _ctx.showShortcuts,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = $event => (_ctx.showShortcuts = $event)),
      closeBtn: ""
    }, {
      default: _withId(() => [
        _hoisted_38
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      title: "Placeholders",
      icon: "tag",
      modelValue: _ctx.showPlaceholders,
      "onUpdate:modelValue": _cache[15] || (_cache[15] = $event => (_ctx.showPlaceholders = $event)),
      closeBtn: ""
    }, {
      default: _withId(() => [
        _hoisted_39
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_modal, {
      title: "Dev-Mode",
      icon: "code",
      modelValue: _ctx.showDevMode,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = $event => (_ctx.showDevMode = $event)),
      closeBtn: ""
    }, {
      default: _withId(() => [
        _hoisted_40,
        _hoisted_41
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})